import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import DBOperationsComb from "src/utils/dbOperationsComb";
import { useUserStore } from "src/stores/userStore";

const tableName =
  Constants.enums.TABLES_NAME_ENUM.FORM_TEMPLATES_RESPONSES_TABLE;

async function getFormTemplatesReponseList(
  config,
  customTableName = null,
  offlineFirst = true
) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: customTableName || tableName,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function getTotalSubmissionsCount(queryParams) {
  try {
    const userStore = useUserStore();
    if (!userStore.isOnline) {
      return {
        error: "Total submissions count is not supported offline"
      };
    }

    return await DBOperationsComb.fetchData({
      tableName: tableName,
      fetchAll: true,
      queryParams: queryParams,
      headOnly: true
    });
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function getFormTemplateResponseById(id, offlineFirst = true) {
  try {
    const _res = await DBOperationsComb.getData(tableName, id, offlineFirst);
    if (_res.error) throw _res.error;
    return _res;
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

/**
 * Every saved snapshot of one response, oldest version first. Each row is the
 * whole response row as it was before an edit (`entity_content`), written by
 * the save_form_templates_responses_version trigger. Online only.
 *
 * @returns {Promise<{data: Array|null, totalItems: number, error: string|null}>}
 */
async function getResponseHistory(responseId) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.FORM_VERSION_HISTORY_TABLE,
        queryParams: [
          { field: "entity_id", value: responseId },
          { field: "entity_type", value: tableName }
        ],
        sortField: "version",
        sortOrder: 1,
        fetchAll: true
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return { data: null, totalItems: 0, error };
  }
}

async function setFormTemplateResponse(data, offlineFirst = true) {
  try {
    let _res = null;
    if (data.id) {
      // updating existing record
      _res = await DBOperationsComb.updateData(tableName, data, offlineFirst);
    } else {
      // adding new record
      _res = await DBOperationsComb.insertData(tableName, data, offlineFirst);
    }

    if (_res.error) throw _res.error;
    return _res;
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function getDistinctValues(columnNames, offlineFirst = true) {
  return await DBOperationsComb.getDistinctColumnValues(
    tableName,
    columnNames,
    offlineFirst
  );
}

export default {
  getFormTemplatesReponseList,
  getTotalSubmissionsCount,
  getFormTemplateResponseById,
  getResponseHistory,
  setFormTemplateResponse,
  getDistinctValues
};
